<template>
  <div>
    <hardware-form operation="bind"></hardware-form>
  </div>
</template>

<script>
import HardwareForm from './components/hardware-form'

export default {
  name: 'hardware-bind',

  components: {
    HardwareForm
  }
}
</script>

